export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  meta: string;
  badge: string;
  backdrop: string;
  targetId: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "slide-changye",
    title: "长夜将明",
    subtitle:
      "连续七年，同一座城市在同一个雨夜发生同一种案件。新上任的痕迹检验师发现，所有卷宗里都缺了同一张现场照片。",
    meta: "2025 · 悬疑刑侦 · 全 24 集 · 评分 9.0",
    badge: "本周热播榜首",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20Chinese%20city%20alley%20at%20night%2C%20a%20forensic%20investigator%20in%20a%20dark%20coat%20holding%20a%20flashlight%2C%20wet%20asphalt%20reflecting%20amber%20street%20lamps%2C%20deep%20navy%20blue%20tones%2C%20atmospheric%20mist%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hero-changye-01&orientation=landscape",
    targetId: "chang-ye-jiang-ming",
  },
  {
    id: "slide-xinghai",
    title: "星海拾梦",
    subtitle:
      "深空站失控前十分钟，值夜工程师收到一条来自地球的语音，发件人是二十年前的自己。为了救回整支船队，他必须先学会放弃。",
    meta: "2024 · 科幻剧情 · 126 分钟 · 评分 8.7",
    badge: "近期最高分电影",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20lone%20astronaut%20floating%20above%20a%20glowing%20planet%20horizon%2C%20deep%20navy%20void%20with%20warm%20amber%20sunlight%20rim%20light%2C%20distant%20space%20station%20silhouette%2C%20atmospheric%20nebula%20haze%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hero-xinghai-02&orientation=landscape",
    targetId: "xing-hai-shi-meng",
  },
  {
    id: "slide-changan",
    title: "长安旧事",
    subtitle:
      "天宝年间的长安城，一名掌管文书的小吏意外得到半卷残破的户籍册。为了替素不相识的百姓讨回姓名，他走进了一场无人愿意触碰的旧案。",
    meta: "2023 · 古装剧情 · 132 分钟 · 评分 8.9",
    badge: "口碑经典",
    backdrop:
      "https://readdy.ai/api/search-image?query=Grand%20cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%2C%20a%20scholar%20in%20Tang%20dynasty%20robes%20walking%20along%20stone%20steps%2C%20hanging%20lanterns%20glowing%20amber%2C%20deep%20navy%20evening%20sky%2C%20drifting%20mist%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hero-changan-03&orientation=landscape",
    targetId: "chang-an-jiu-shi",
  },
  {
    id: "slide-wugang",
    title: "雾港迷城",
    subtitle:
      "一座常年被海雾笼罩的港口小城，接连出现三起毫无关联的失踪案。退休刑警陆铮被迫重返一线，在潮水与谎言之间，一点点拼出被掩埋了十二年的真相。",
    meta: "2024 · 犯罪悬疑 · 118 分钟 · 评分 8.6",
    badge: "犯罪片精选",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20foggy%20container%20harbour%20at%20night%2C%20a%20detective%20silhouette%20on%20a%20pier%20with%20cargo%20cranes%20fading%20into%20thick%20mist%2C%20deep%20navy%20and%20amber%20dock%20lights%2C%20wet%20ground%20reflections%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hero-wugang-04&orientation=landscape",
    targetId: "wu-gang-mi-cheng",
  },
];